import { faDatabase } from "@fortawesome/pro-regular-svg-icons/faDatabase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Stack, Typography } from "@mui/material";
import { MprcButton } from "components";
import { Formaters } from "lib/Formaters";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { useCardContext } from "../../CardBuilder";
import { DefaultOptions } from "../common/DefaultOptions";
import { WhoViewButton } from "../common/Interaction";


///
const ViewListButton = () => {
    const { pub: { publicationId } } = useCardContext();
    const navigate = useNavigate();
    const { t } = useTranslation("knowledge");

    return (
        <MprcButton sx={theme => ({ color: theme.palette.primary.light })} onClick={() => navigate(`${KnowledgePaths.ListPublicationViewer}/${publicationId}`)}>
            <Typography variant="body1" color="primary.light" component="div">
                {t("Feed.Card.List.ViewListButtonText")}
            </Typography>
        </MprcButton>
    );
};

export const PublicationAdminFooter = () => {

    const { pub: { otherInfo: { totalStorageSize } } } = useCardContext();
    const { t } = useTranslation("knowledge");

    const StorageSizeBox =
        <Typography variant={"iconText"} component="div">
            <Stack spacing={1} direction="row" alignItems="center">
                <FontAwesomeIcon icon={faDatabase} title={t("Feed.PublicationAdmin.StorageSizeTooltip")} />
                <span> {Formaters.fileSize(totalStorageSize)}</span>
            </Stack>
        </Typography>;

    return (
        <Grid container justifyContent="space-between" alignItems="center">
            <Grid>
                <ViewListButton />
            </Grid>
            <Grid>
                <Grid container spacing={3} alignItems="center" justifyContent="center">
                    <Grid>
                        <WhoViewButton />
                    </Grid>
                    <Grid>
                        {totalStorageSize > 0 && StorageSizeBox}
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <DefaultOptions />
            </Grid>
        </Grid>
    );
};
